<ng-container *ngIf="communicationPortalAccess">
<section class="mass-communication-container">
  <p class="communicationHeader capability-Header-font">Mass Communication</p>
  <div class="main-div-with-white-bkg no-border-bkg p-4 m-0">
 
    <div class="row">
      <div class="create-template-header col-12 d-flex justify-content-center align-items-center">
        <button mat-raised-button class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
          (click)="createNewTemplate()">{{createNewTemplateFlag ? 'Existing Templates' : 'Create New Template'}}</button>
    
      </div>
      <form #emailForm="ngForm">
      <div class="d-flex align-items-center mt-4">
        <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="maskingMsg">Select Template</label>
          <app-dropdown-with-search [Pixeltracking]="true" [showPlaceholder]="'false'" searchFlag="true"
            isMultiSelect="false" [dropdownData]="templates"
            (selectionChange)="onTemplateChange($event?.data)"></app-dropdown-with-search>
        </div>
        <div class="cm-fields" *ngIf="createNewTemplateFlag">
          <label for="maskingMsg">Template Name</label>
          <mat-form-field class="inline-form-edit" floatLabel="never" appearance="outline">
            <input placeholder="Enter template name" (input)="onInputFieldChanged()" matInput [(ngModel)]="templateName" name="templateName">
          </mat-form-field>
        </div>
        <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="cmgroup">Communication Group:</label>
          <app-dropdown-with-search [Pixeltracking]="true" [showPlaceholder]="'false'" searchFlag="true"
            isMultiSelect="true" [dropdownData]="cmgrpList"
            (selectionChange)="onCommunityChange($event?.data)"></app-dropdown-with-search>
        </div>
         <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="cmgroup">BCC Group:</label>
          <app-dropdown-with-search [Pixeltracking]="true" [showPlaceholder]="'false'" searchFlag="true"
            isMultiSelect="true" [dropdownData]="cmgrpList"
            (selectionChange)="onBccChange($event?.data)"></app-dropdown-with-search>
        </div>
        
      </div>

      <div class="d-flex align-items-center mt-4">

         <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="cmgroup">CC Group:</label>
          <app-dropdown-with-search [Pixeltracking]="true" [showPlaceholder]="'false'" searchFlag="true"
            isMultiSelect="true" [dropdownData]="cmgrpList"
            (selectionChange)="onCcChange($event?.data)"></app-dropdown-with-search>
        </div>
        <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="maskingMsg">Masking Message:</label>
          <mat-form-field class="inline-form-edit" floatLabel="never" appearance="outline">
            <input placeholder="Enter message" (input)="onInputFieldChanged()" matInput [(ngModel)]="maskingMsg" name="maskingMsg">
          </mat-form-field>
        </div>

        <div class="cm-fields" *ngIf="!createNewTemplateFlag">
          <label for="cmSubject">Subject:</label>
          <mat-form-field class="inline-form-edit" floatLabel="never" appearance="outline">
            <input placeholder="Enter subject" (input)="onInputFieldChanged()" matInput [(ngModel)]="cmSubject" name="cmSubject">
          </mat-form-field>
        </div>

      </div>

      <div class="d-flex align-items-center mt-4">
        
        <div class="cm-fields d-grid">
          <label for="uploadFile">Attachment:</label>
          <input type="file" class="mt-3 file-field" #fileInput id="uploadFile" (change)="onFileSelected($event)" name="uploadFile" multiple/>
        </div>
        <div class="cm-fields">
          <label for="Users">User:</label>
          <div class="funding-chip-field lob-border">
            <ng-container class="example-chip-list">
              <mat-form-field (click)="focusOnInput()" class="inline-form-edit funding-names-chip chip-fields"
                floatLabel="never">
                <mat-chip-grid #chipList1>
                  <mat-chip-row class="stk-mat-chip" *ngFor="let owner of selectedUsers" (removed)="remove(owner.msid)">
                    <span title="{{owner.msid}}" style="cursor: pointer;">
                      {{owner.msid}}
                    </span>
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                </mat-chip-grid>
                <input #inputAddOwner class="funding-chip-input" placeholder="Search by Name/Mail" [matAutocomplete]="auto"
                  (keyup)="keyUpSearch($event)" [matChipInputFor]="chipList1"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                  (optionSelected)="selected($event)">
    
                  <mat-option *ngFor="let user of searchUserList"
                    title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})" [disabled]="checkExistUser(user)"  [value]="user">
                    {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
        
      </div>
      </form>

      <div class="w-100 mt-3">
        <div class="editor-container">
          <label for="message-editor">Message:</label>
          <!-- <ckeditor [editor]="Editor" [(ngModel)]="messageContent" (ngModelChange)="onEditorChanges()"
            [config]="editorConfig"></ckeditor> -->
          <app-custom-editor [createNewTemplateFlag]="createNewTemplateFlag"  [messageContent]="messageContent" (updatedContent)="getUpdatedContent($event)"></app-custom-editor>
        </div>
      </div>
    </div>
    
    <div class="row mt-4">
      <div class="col-12 text-align-right">
        <button mat-raised-button *ngIf="!createNewTemplateFlag && selectedTemplate?.templateName" [disabled]="disableUpdateButton" class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button me-3" type="submit" (click)="updateTemplate()">Update Template</button>
        <button mat-raised-button class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button" type="submit" (click)="sendEmail()" [disabled]="disableEmailButton" *ngIf="!createNewTemplateFlag">Send Email</button>
        <button mat-raised-button class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button" type="submit" (click)="createTemplate()" [disabled]="disableCreateButton" *ngIf="createNewTemplateFlag">Create Template</button>
      </div>
    </div>
  </div>
</section>
</ng-container>


<ng-container *ngIf="communicationPortalAccess == false">
  <div class="unauthorized-container">
      <div>
        <div class="errorTitle-search"> Unauthorized to view this page. Please contact Techops team.</div>
      </div>
  </div>
</ng-container>